import React, { useState, useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import api from "../Authentication/authService";
import { useDispatch, useSelector } from "react-redux";
import { LoginSucessfull } from "../../context/AuthenticationSlice";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { PaymentStatus } from "../../context/PaymentStatusSlice";
import withReactContent from "sweetalert2-react-content";
import { CONFIG } from "../../config";
import Toast from "../../Toast/Toast";
import DetailsNavbar from "../DetailsNavbar/DetailsNavbar";
import Footer from "../Footer/Footer";

function Login() {

  const [toast, setToast] = useState(null);

  const { CredenceAccountNumber } = useSelector(
    (state) => state.Authentication
  );
  const MySwal = withReactContent(Swal);

  const [captcha, setCaptcha] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Function to generate a random CAPTCHA
  const generateCaptcha = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let captchaCode = "";
    for (let i = 0; i < 6; i++) {
      captchaCode += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    setCaptcha(captchaCode);
  };

  useEffect(() => {
    generateCaptcha();
    Cookies.remove("Token");
    Cookies.remove("RefreshToken");
  }, []);

  const apiUrl = CONFIG.REACT_APP_API_BASE_URL;;

  const handleLogin = async (values, { resetForm }) => {
    // if (captcha != values.captcha) {
    //   setToast({
    //     type: "error",
    //     message: "Captcha is not correct.",
    //   });
    //   return;
    // }

    await api
      .post(`${apiUrl}/LoginAPI`, values)
      .then((response) => {
        if (response.status === 200) {
          const { token, refreshToken } = response.data;

          dispatch(
            LoginSucessfull({
              CredenceAccountNumber: values.CredenceAccountNumber,
              LastName: values.LastName,
              SSN: values.ssn,
            })
          );

          dispatch(
            PaymentStatus({
              paymentPlanStatus: "",
              paymentStatus: "",
            })
          );

          // Cookies.remove("Token");
          // Cookies.remove("RefreshToken");
         
          Cookies.set("Token", token);
          Cookies.set("RefreshToken", refreshToken);

          resetForm();

          if (token != null) {
            navigate("/Profile");
            window.scrollTo({ top: 0, behavior: "smooth" });
          } else if (
            response.data.validationResult ==
            "Your account is no longer assigned to Credence Resource Management, LLC. Please contact the creditor."
          ) {
            setToast({
              type: "warning",
              message:
                "Your account is no longer assigned to Credence Resource Management, LLC, please contact the creditor.",
            });
          } else if (
            response.data.validationResult ==
            "Your account is no longer associated  to Credence Resource Management, LLC. Please call back on +1-855-880-4791 for assistance."
          ) {
            setToast({
              type: "warning",
              message:
                "Your account is no longer associated to Credence Resource Management, LLC. Please call back on +1-855-880-4791 for assistance.",
            });
          } else {
            setToast({
              type: "error",
              message:
                "Login failed. Please call back on +1-855-880-4791 for assistance.",
            });
          }
        } else {
          setToast({
            type: "error",
            message: "Something went wrong, please try again.",
          });
        }
      })
      .catch(() => {
        setToast({
          type: "error",
          message: "Something went wrong, please try again.",
        });
      });
  };

  const validationSchema = Yup.object().shape({
    CredenceAccountNumber: Yup.number()
      .typeError("Credence Account Number should be an integer")
      .positive("Credence Account Number should be a positive number")
      .integer("Credence Account Number should be an integer")
      .required("Credence Account Number is required")
      .max(
        99999999999999999999,
        "Credence Account Number should not be more than 20 digits"
      ),
    lastName: Yup.string()
      .required("Last Name is required")
      .max(50, "Last Name should not exceed 50 characters"),
    // .matches(/^[a-zA-Z0-9\s!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|`~]+$/, 
    //   "Last Name contains invalid characters"),

    ssn: Yup.string().matches(/^\d{4}$/, "SSN must be exactly 4 digits"),
    zip: Yup.string().matches(
      /^\d{5}$/,
      "ZIP Code must be exactly 5 digits"
    ),
    captcha: Yup.string().required("Captcha is required"),
  });

  return (
    <>
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
      <DetailsNavbar />
      <main className="container-fluid p-0">
        <section className="login-section" aria-labelledby="login-heading">
          <div className="login-container">
            <div className="login-visual-content">
              <div className="login-img">
                <img src="./assets/images/modern-female-device-1.webp" width="auto" alt="" role="presentation" />
              </div>
            </div>
            <div className="form-section">
              <Formik
                initialValues={{
                  CredenceAccountNumber: "",
                  lastName: "",
                  zip: "",
                  ssn: "",
                  captcha: "",
                }}
                validationSchema={validationSchema}
                validateOnChange={true}
                validate={(values) => {
                  const errors = {};
                  if (!values.ssn && !values.zip) {
                    errors.ssn = "Either SSN or ZIP code is required";
                    //errors.zip = 'Either SSN or ZIP code is required';
                  }
                  // if (captcha != values.captcha) {
                  //   errors.captcha = "Invalid Captcha";
                  // }
                   if ("Test123" != values.captcha) {
                    errors.captcha = "Invalid Captcha";
                  }
                  return errors;
                }}
                onSubmit={handleLogin}
              >
                {({ values, handleChange, handleBlur, isSubmitting }) => (
                  <Form>
                    <div className="card">
                      <div className="card-body px-5">
                        <div className="row">
                          <div className="col-md-12 text-center">
                            <h3 className="mb-4 lgn-text">
                              Log in to Your Account
                            </h3>
                          </div>
                          <div className="col-md-12">
                            <label
                              className="form-label"
                              htmlFor="CredenceAccountNumber"
                            >
                              Credence Account Number{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="CredenceAccountNumber"
                              id="CredenceAccountNumber"
                              placeholder="Enter Credence Account Number"
                              onChange={handleChange}
                              onKeyDown={(e) => {
                                if (
                                  [8, 9, 13, 27, 46, 37, 38, 39, 40].includes(
                                    e.keyCode
                                  ) ||
                                  (e.ctrlKey &&
                                    ["a", "c", "v", "x"].includes(
                                      e.key.toLowerCase()
                                    ))
                                ) {
                                  return;
                                }
                                if (!/^\d$/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              aria-required="true"
                            />
                            <div className="Error-msg">
                              <ErrorMessage
                                name="CredenceAccountNumber"
                                component="div"
                                className="text-danger"
                                aria-live="assertive"
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <label className="form-label" htmlFor="lastName">
                              Last Name <span className="text-danger">*</span>
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="lastName"
                              id="lastName"
                              placeholder="Enter Last Name"
                              onChange={handleChange}
                              aria-required="true"
                            />
                            <div className="Error-msg">
                              <ErrorMessage
                                name="lastName"
                                component="div"
                                className="text-danger"
                                aria-live="assertive"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row align-items-center">
                          <div className="col-md-6">
                            <label className="form-label" htmlFor="ssn">
                              Last 4 digits of SSN
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="ssn"
                              id="ssn"
                              maxLength="4"
                              placeholder="Enter Last 4 digit of SSN"
                              onChange={handleChange}
                            />
                            <div className="Error-msg">
                              <ErrorMessage
                                name="ssn"
                                component="div"
                                className="text-danger"
                                aria-live="assertive"
                              />
                            </div>
                          </div>
                          <div className="col-md-1 d-flex justify-content-center">
                            <span aria-hidden="true">OR</span>
                          </div>
                          <div className="col-md-5">
                            <label className="form-label" htmlFor="zip">
                              5 Digit Zip Code
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="zip"
                              id="zip"
                              maxLength="5"

                              placeholder="Enter Zip Code"
                              onChange={handleChange}
                              aria-required="true"
                            />
                            <div className="Error-msg">

                              <ErrorMessage
                                name="zip"
                                component="div"
                                className="text-danger"
                                aria-live="assertive"
                              />
                            </div>
                          </div>
                        </div>

                        {/* <div className="error-container">
                          
                          </div> */}
                        <div className="row d-flex align-items-end">
                          <div className="col-md-6 mb-3">
                            <label className="form-label" htmlFor="captcha">
                              Enter Captcha <span className="text-danger">*</span>
                            </label>
                            <Field
                              className="form-control"

                              type="text"
                              name="captcha"
                              value={values.captcha}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              onPaste={(e) => {
                                e.preventDefault();
                              }}
                              placeholder="Enter Captcha"
                              aria-required="true" aria-describedby="captcha-help"
                            />
                            <div className="Error-msg">
                              <ErrorMessage
                                name="captcha"
                                component="div"
                                className="text-danger"
                                aria-live="assertive"
                              />
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <div className="input-group">
                              <div id="captchaPrompt" className="form-control">
                                {captcha}
                              </div>
                              <button
                                className="btn btn-outline-secondary d-flex align-items-center"
                                type="button"
                                onClick={generateCaptcha}
                                aria-label="Refresh Captcha"
                              >
                                <i className="bx bx-refresh" aria-hidden="true"></i>
                              </button>
                            </div>
                            <div className="Error-msg" aria-live="assertive"></div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12 text-center mb-3">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? "Submitting..." : "SUBMIT"}
                            </button>
                          </div>

                          <div className="col-md-12 ">
                            <div className="payment-methods justify-content-center" role="list" aria-label="Accepted payment methods">
                              <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                  <img src="/assets/images/payment-method/visa.webp" alt="Pay with Visa" />
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                  <img src="/assets/images/payment-method/card.webp" alt="Pay with Mastercard" />
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                  <img src="/assets/images/payment-method/google-pay.webp" alt="Pay with Google Pay" />
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                  <img src="/assets/images/payment-method/apple-pay.webp" alt="Pay with Apple Pay" />
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                  <img src="/assets/images/payment-method/discover.webp" alt="Pay with Discover" />
                                </div>
                              </div>
                            </div>
                          </div>
                          

                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </section>




      </main>
      <Footer />

    </>

  );
}

export default Login;
